// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Lookup-RecordForm-styles___form--Fup4_ {
  display: flex;
}

  .components-Lookup-RecordForm-styles___form--Fup4_ .components-Lookup-RecordForm-styles___inputWrapper--cHSqq {
    margin-right: 32px;
    width: 160px;
  }

  .components-Lookup-RecordForm-styles___form--Fup4_ .components-Lookup-RecordForm-styles___inputWrapper--cHSqq.components-Lookup-RecordForm-styles___small--GKDt_ {
      width: 160px;
    }

  .components-Lookup-RecordForm-styles___form--Fup4_ .components-Lookup-RecordForm-styles___inputWrapper--cHSqq:last-child {
      margin-right: 0;
    }

  .components-Lookup-RecordForm-styles___form--Fup4_ .components-Lookup-RecordForm-styles___inputWrapper--cHSqq .components-Lookup-RecordForm-styles___button--rS2UF {
      margin-top: 16px;
    }

  .components-Lookup-RecordForm-styles___form--Fup4_ .components-Lookup-RecordForm-styles___inputWrapper--cHSqq .components-Lookup-RecordForm-styles___selectWrapper--tW1qt {
      width: 100%;
    }
`, "",{"version":3,"sources":["webpack://./components/Lookup/RecordForm/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;AAqBf;;EAnBE;IACE,kBAAkB;IAClB,YAAY;EAgBd;;EAdE;MACE,YAAY;IACd;;EAEA;MACE,eAAe;IACjB;;EAEA;MACE,gBAAgB;IAClB;;EACA;MACE,WAAW;IACb","sourcesContent":[".form {\n  display: flex;\n\n  .inputWrapper {\n    margin-right: 32px;\n    width: 160px;\n\n    &.small {\n      width: 160px;\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    .button {\n      margin-top: 16px;\n    }\n    .selectWrapper {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `components-Lookup-RecordForm-styles___form--Fup4_`,
	"inputWrapper": `components-Lookup-RecordForm-styles___inputWrapper--cHSqq`,
	"small": `components-Lookup-RecordForm-styles___small--GKDt_`,
	"button": `components-Lookup-RecordForm-styles___button--rS2UF`,
	"selectWrapper": `components-Lookup-RecordForm-styles___selectWrapper--tW1qt`
};
module.exports = ___CSS_LOADER_EXPORT___;
